export const REDIRECT_AFTER_LOGIN_KEY = 'redirectAfterLogin';

// Paths worth returning to after a sign-in. Kept per tab (sessionStorage), so a new tab
// returns to the page it asked for, not to the page another tab is on.
export const isRememberablePath = (pathname: string) =>
  !pathname.includes('auth') && !['/', '/dashboard', '/dashboard/', '/404'].includes(pathname);

// Called before every sign-in redirect: the round-trip lands on /auth/callback, and this
// is how the tab finds its way back.
export const rememberCurrentPath = () => {
  const { pathname, search } = window.location;
  if (isRememberablePath(pathname)) {
    sessionStorage.setItem(REDIRECT_AFTER_LOGIN_KEY, pathname + search);
  }
};
